var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroMini',{attrs:{"msg":"Monophasic Cycle","subMsg":"The standard cycle for most, consisting of an 8 hour sleep during the night."}}),_c('CycleCalculator',{attrs:{"msg":"Monophasic Sleeping Cycle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }